import skinColors from "./skinColors";

const skinMap = {
  emerald: "Emerald Green",
  blue: "Corporate Blue",
  purple: "Royal Purple",
  orange: "Sunset Orange",
  slate: "Slate Gray",
  // Add other aliases if you use more
};

export default function getCurrentSkin(skin) {
  const mappedSkin = skinMap[skin] || skin;
  return skinColors[mappedSkin] || skinColors["Emerald Green"];
}
